import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { FieldConfig } from '@smartflip/data-models';
import { createNewFormControl } from '../../../../home-list/add-property-modal/add-property-modal.helper';
import { createWorkflowFieldList } from './property-workflow-modal.helper';
import {
  buyingFields,
  buyingText,
  sellingFields,
  sellingText,
} from './property-workflow-modal.constants';

@Component({
  selector: 'smartflip-property-workflow-modal',
  templateUrl: './property-workflow-modal.component.html',
  styleUrls: ['./property-workflow-modal.component.scss'],
  standalone: false,
})
export class PropertyWorkflowModalComponent implements OnInit {
  @Input() data: { isBuying: boolean };

  public modalTitle: string;
  public updateForm: UntypedFormGroup;
  public fieldList: FieldConfig[];

  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
  ) {}

  cancel() {
    this.modalController.dismiss();
  }

  save() {
    const { solddate, purchasedate, sell, price } = this.updateForm.value;

    this.modalController.dismiss({
      newDate: solddate || purchasedate,
      newDollarAmount: sell || price,
      updatePurchaseDate: this.data.isBuying,
    });
  }

  ngOnInit() {
    this.fieldList = createWorkflowFieldList(
      this.data.isBuying ? buyingFields : sellingFields,
    );
    const formShape = this.fieldList.reduce(
      (formObj, frmFld) => ({
        ...formObj,
        [frmFld.name]: createNewFormControl(
          frmFld.name,
          this.data[frmFld.name],
        ),
      }),
      {},
    );

    this.updateForm = this.formBuilder.group(formShape);
    this.modalTitle = this.data.isBuying ? buyingText : sellingText;
  }
}
